import React from 'react'
import { Route } from 'react-router-dom'
import { VisualizerContainer } from './components/Visualizer/Visualizer'

export class Layout extends React.Component
{
    render() {
        return (
            <div>
                {/* TODO FIXME possible regex for optional "/" ? */}
                <Route path="/ark:/:naan/:arkName/:uuid" component={ VisualizerContainer } />
                <Route path="/ark::naan/:arkName/:uuid" component={ VisualizerContainer } />
            </div>
        )
    }
}
